import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Carbon sequestration by producers constitutes a vital ecological
              function executed by ecosystems to mitigate global warming due to
              burgeoning sustained anthropogenic activities with the release of
              greenhouse gases (carbon dioxide, methane, carbon monoxide, etc.).
              The Current study evaluates carbon dynamics in forest ecosystems
              through the InVest model with the temporal land use analyses using
              remote sensing data from 1973 to 2021 in the Chikamagaluru
              district of Karnataka. The land use dynamics are assessed using
              temporal remote sensing data through a machine learning-based
              supervised Random Forest algorithm, which shows a decline in
              forest cover of 28.98%, an increase in agricultural area by 5.31%,
              and horticulture by 42.52% in the last five decades which has led
              to the depletion of carbon stock by 30683.81 Gg. Land use changes
              have a long-term effect on climatic variables, leading to changes
              in local temperature, annual rainfall, and number of rainy days in
              the study area.
            </p>
            <p>
              <strong>Keywords:</strong> Landscape dynamics, Carbon
              sequestration, Climate Change, InVEST, &nbsp;
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
